import { render } from "./ServiceCounterView.vue?vue&type=template&id=60a3b54c&ts=true"
import script from "./ServiceCounterView.vue?vue&type=script&lang=ts"
export * from "./ServiceCounterView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__